import axios from 'axios';
import * as Config from '../../config';

const state = { };

const actions = {
    notificacionPushAutomatica_get({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'notificacion-push-automatica/get')
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    notificacionPushAutomatica_store({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'notificacion-push-automatica/' + form.dia, form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
}

const mutations = { };

export default {
    state,
    actions,
    mutations
};